module.exports = __webpack_public_path__ + "static/img/news3.6be5ac3f.png";